import { defineComponent as _defineComponent } from 'vue'
import BaseChip from "@/components-UI/BaseChip.vue";
import { IStatus } from "@/types";

interface Props {
    status: IStatus,
    isLarge?: boolean,
    isOutline?: boolean
    disableHover?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseStatus',
  props: {
    status: null,
    isLarge: { type: Boolean },
    isOutline: { type: Boolean },
    disableHover: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    status: IStatus,
    isLarge?: boolean,
    isOutline?: boolean
    disableHover?: boolean,
}



return { __sfc: true,props, BaseChip }
}

})